import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';

import { BLACK } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

import { getReliabilityScoreColors, getReliabilityScorePercent } from './reliabilityScoreConstants';

const AlsTooltipContent = ({ score }) => {
  const displayScore = typeof score === 'number' ? getReliabilityScorePercent(score) : '--';
  const { gradientStart, gradientEnd } = getReliabilityScoreColors(score);

  return (
    <Box data-testid="als-tooltip" sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <Box
        component="span"
        sx={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          background: `linear-gradient(to bottom, ${gradientStart}, ${gradientEnd})`,
        }}
      />
      <Typography sx={{ fontFamily: PRIMARY_FONT[400], fontSize: '14px', color: BLACK[60] }}>
        {LanguageConverterV2('jobOrder.roster.als')}
      </Typography>
      <Typography sx={{ fontFamily: PRIMARY_FONT[700], fontSize: '14px', color: BLACK[100] }}>
        {displayScore}
      </Typography>
    </Box>
  );
};

AlsTooltipContent.propTypes = {
  score: PropTypes.number,
};

export default AlsTooltipContent;
